const Omnibus = (() => {
    const Selectors = {
        PLACEHOLDER: '.js_product-thumb-omnibus'
    };

    class Omnibus {
        constructor() {
            window.addEventListener('firstInteraction', () => {
                this.addOmnibusLabel();
            });
        }
        addOmnibusLabel(){
            const thumbs = document.querySelectorAll(Selectors.PLACEHOLDER);
            thumbs.forEach(t => {
                t.innerText = "*najniższa cena w okresie 30 dni przed obniżką";
            })
        }
    }
    return new Omnibus();

})();

export default Omnibus;
